export enum SortDirection {
    ASC, DESC
}
